import { Grid } from "@mui/material";
import TitleHeading from "./title-heading";
import TitleDescription from "./title-description";

const Title3 = ({
    title,
    description,
    chipLabel="",
    chipIcon=null,
    chipColor,
    removePb=false
}) => {
    return (
        <>
            <Grid
                direction='column'
                justifyContent='start'
                alignItems='start'
                sx={{
                    width: '100%',
                    pb: {xs: removePb ? 0 : 2, md: removePb ? 0 : 5}
                }}
                spacing={{xs: 1, md: 1.5}}
                container
            >
                <Grid
                    size={{xs: 12, md: 6}}
                    width='100% !important'
                >
                    <TitleHeading 
                        title={title} 
                        textAlign="left"
                        chipLabel={chipLabel}
                        chipIcon={chipIcon}
                        chipColor={chipColor}
                        chipAlignment="start"
                    />
                </Grid>

                <Grid
                    size={{xs: 12, md: 6}}
                    width='100% !important'
                >
                    <TitleDescription description={description} textAlign="left"/>
                </Grid>
            </Grid>
        </>
    );
}

export default Title3;